import React, { useState, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { ModalBase, sendCustomTrackingInfo } from '@panel/commons';
import { getDevice, getPublisherScoreValue, getPublisherTypeNameDL, momentFormaterISO } from '@panel/commons/helpers';
import { useQuery } from '@panel/commons/hooks';
import { useTranslation } from 'react-i18next';
import { userInfoSelectors } from '@panel/core/src/state/ducks/user';
import { reputationLevelSelectors } from '@panel/core/src/state/ducks/reputationLevel';
import Cookies from 'js-cookie';
import { bumexFeaturesKeys } from '@panel/core/src/constants/bumexFeatures';
import { bumexFeatureSelectors } from '@panel/core/src/state/ducks/bumexFeatures';
import TourEstadisticas from '../TourPanel/TourEstadisticas';
import TourReputationLevel from '../TourPanel/TourReputationLevel';
import { ContainerLayout, LeftBar, Main, AlertContainer } from './styles';
import PageHeader from './PageHeader';
import Tabs from './Tabs';
import PublisherDetail from '../PublisherDetail';
import { dataStatisticsAdapter } from '../dataStatisticsAdapter';
import { dataStatisticsChartAdapter } from '../dataStatisticsChartAdapter';
import { FilterOperations, FilterSelectors } from '../../ducks/filtros';
import { RendimientoSelectors, RendimientoOperations } from '../../ducks/rendimiento';
import { ReputationSelectors, ReputationOperations } from '../../ducks/reputation';
import { ScoreSelectors, ScoreOperations } from '../../ducks/score';
import { dateFormatted } from '../../helpers/datesFormatHelper';
import Skeleton from '../Skeleton';
import Header from '../Header';
import FooterInformation from '../FooterInformation';
import Reputation from './Tabs/Reputation';
import Score from './Tabs/Score';
import Performance from './Tabs/Performance';
import Alert from '../Alert/Alert';
import TourModal from '../Modals/TourModal';
import { Modal } from '../Modals/ModalWrapper';

const siteId = process.env.REACT_APP_BUILD_SITE;
const portalWithTelBanner = ['IWBR', 'WIBR'].includes(siteId);

const EstadisticasContainer = () => {
  const { t } = useTranslation();
  const device = getDevice();
  const history = useHistory();
  const dispatch = useDispatch();
  const { bumexFeatures } = useSelector(bumexFeatureSelectors.getBumexFeatureState);
  const isPortalWithNewReputation = bumexFeatures.get(bumexFeaturesKeys.NEW_REPUTATION_SECTION);
  const [tabLocation] = useQuery(useLocation(), ['tab']);
  const [leadsData, setLeadsData] = useState();
  // estado para control de ejecucion unica de DL para el render de la pantalla de estadisticas
  const [renderStatisticsDLSend, setRenderStatisticsDLSend] = useState(false);
  const [leadsChartData, setLeadsChartData] = useState();
  const [updateData, setUpdateData] = useState({ date: null, hour: null });
  const [chartType, setChartType] = useState('impressions');
  const [currentTab, setCurrentTab] = useState(() => {
    if (!tabLocation && isPortalWithNewReputation) {
      return 'score';
    }
    return tabLocation || 'performance';
  });
  const [branchSelected, setBranchSelected] = useState({ branchId: '', name: '' });
  const [showTourModal, setShowTourModal] = useState(false);
  const [showTourStatistics, setShowTourStatistics] = useState(false);
  const [showTourReputation, setShowTourReputation] = useState(false);
  const { name, premier, urlLogo, userTypeId, isLoading, email, userLoggedId, publisherTypeId, isSeeker } = useSelector(
    userInfoSelectors.getuserInfoState
  );
  const { mainReputationLevel } = useSelector(ScoreSelectors.getReputationState);

  const {
    postingLeads,
    loadingPostingLeads,
    postingLeadsCharts,
    loadingCharts,
    hasPostingLeads,
    hasPostingLeadsCharts,
    leadsError,
    leadsChartsError
  } = useSelector(RendimientoSelectors.getRendimientoState);
  const { getRatings, getQuality, getReports } = ReputationOperations;
  const { getScore } = ScoreOperations;

  const { loadingRatings, loadingReports, loadingQuality, hasRatings, hasReports, hasQuality, branches } = useSelector(
    ReputationSelectors.getReputationState
  );
  const { levelValue } = useSelector(reputationLevelSelectors.reputationLevelState);

  const { getPostingLeads, getPostingLeadsCharts } = RendimientoOperations;
  const { headerFilter, startFilter, endFilter } = useSelector(FilterSelectors.getFiltersState);
  const { appliedFilter } = FilterOperations;
  const isDesktop = device === 'desktop';
  const isAdmin = ['1', '2'].includes(userTypeId);
  const userIsParticular = publisherTypeId === '1' || isSeeker;
  const date = new Date();
  const isVAEnabledPublisher = false;
  const hideTourModalCookie = Cookies.get('hideTourStatisticsVA');
  const reputationModalLevelCookie = Cookies.get('reputationModalLevelSeen2');
  const hideTourReputationCookie = Cookies.get('reputationTourLevelSeen');
  const enabledTourReputation =
    !isLoading &&
    // Se valida con el email que el usuario esté logueado:
    email &&
    // Se valida que esté en un portal habilitado:
    isPortalWithNewReputation &&
    // Se valida que el usuario no sea particular:
    !userIsParticular &&
    // Validamos mediante cookie que se haya mostrado previamente el ReputationLevelModal:
    !!reputationModalLevelCookie;

  const selectFilterList = {
    firstPeriod: 7,
    secondPeriod: 30,
    thirdPeriod: 90,
    customPeriod: 0
  };

  const setQueryTab = newTab => {
    const params = new URLSearchParams(window.location.search);
    if (tabLocation !== newTab) {
      params.set('tab', newTab);
    }
    history.replace({ search: params.toString() });
  };

  const reloadDispatch = () => {
    dispatch(getPostingLeads(selectFilterList[headerFilter]));
    dispatch(getPostingLeadsCharts(selectFilterList[headerFilter]));
  };

  const updateFilter = (option, startPeriod, endPeriod) => {
    dispatch(appliedFilter({ filter: option, filterStartPeriod: startPeriod, filterEndPeriod: endPeriod }));
  };

  const closeTourModal = () => {
    if (!hideTourModalCookie) {
      Cookies.set('hideTourStatisticsVA', 'hide', { expires: 999 });
    }
    setShowTourModal(false);
  };

  const onCloseTourInModal = () => {
    // Lo usamos para cerrar el modal sin iniciar el Tour.
    closeTourModal();
    sendCustomTrackingInfo({
      event: 'click_modal',
      modal_name: 'Modal de bienvenida tour virtual',
      selection_value: 'Cerrar'
    });
  };

  const getSectionContent = tab => {
    if (tab === 'reputation' && !isPortalWithNewReputation) {
      return <Reputation device={device} />;
    }

    if (tab === 'score' && isPortalWithNewReputation) {
      return (
        <Score
          device={device}
          renderStatisticsDLSend={renderStatisticsDLSend}
          setRenderStatisticsDLSend={setRenderStatisticsDLSend}
          siteId={siteId}
          isPortalWithNewReputation={isPortalWithNewReputation}
        />
      );
    }

    return (
      <Performance
        leadsData={leadsData || ''}
        leadsChartData={leadsChartData}
        chartType={chartType}
        setChartType={setChartType}
        device={device}
        headerFilter={headerFilter}
        startFilter={startFilter}
        endFilter={endFilter}
        leadsError={leadsError}
        leadsChartsError={leadsChartsError}
        reloadDispatch={reloadDispatch}
      />
    );
  };

  const getLoadingState = () => {
    if (currentTab === 'reputation' || currentTab === 'score')
      return (
        (loadingRatings && (!hasRatings || branches)) ||
        (loadingReports && !hasReports) ||
        (loadingQuality && !hasQuality)
      );
    return loadingPostingLeads || loadingCharts;
  };

  useEffect(() => {
    if (userLoggedId && !isPortalWithNewReputation && mainReputationLevel) {
      sendCustomTrackingInfo({
        event: 'track_content_group',
        content_group: 'Panel',
        content_type: 'Estadisticas',
        user_id: userLoggedId,
        user_type: getPublisherTypeNameDL(publisherTypeId),
        user_reputation: getPublisherScoreValue(mainReputationLevel)
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userLoggedId, mainReputationLevel]);

  useEffect(() => {
    Cookies.set('statisticTooltipSeen', true);
    // Se realiza petición para Sección de RENDIMIENTO:
    if (headerFilter === 'customPeriod') {
      dispatch(getPostingLeads(selectFilterList[headerFilter], dateFormatted(startFilter), dateFormatted(endFilter)));
      dispatch(
        getPostingLeadsCharts(selectFilterList[headerFilter], dateFormatted(startFilter), dateFormatted(endFilter))
      );
    } else {
      dispatch(getPostingLeads(selectFilterList[headerFilter]));
      dispatch(getPostingLeadsCharts(selectFilterList[headerFilter]));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [headerFilter, startFilter, endFilter]);

  useEffect(() => {
    // Se setean en los estados los datos de los gráficos para la sección de Rendimiento:
    if (postingLeads) {
      setLeadsData(dataStatisticsAdapter(postingLeads));
    }
    if (postingLeadsCharts) {
      setLeadsChartData(dataStatisticsChartAdapter(postingLeadsCharts));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postingLeads, postingLeadsCharts]);

  useEffect(() => {
    // Se realiza petición para datos de Sección de REPUTACIÓN:
    if (currentTab === 'reputation') {
      if (branchSelected.branchId) {
        dispatch(getRatings(branchSelected.branchId));
        dispatch(getQuality(branchSelected.branchId));
        dispatch(getReports());
      } else {
        dispatch(getRatings());
        dispatch(getQuality());
        dispatch(getReports());
      }
    }

    if (currentTab === 'score' && isPortalWithNewReputation) {
      if (branchSelected.branchId) {
        dispatch(getRatings(branchSelected.branchId));
        dispatch(getQuality(branchSelected.branchId));
        dispatch(getReports());
        dispatch(getScore(branchSelected.branchId, siteId));
      } else {
        dispatch(getRatings());
        dispatch(getQuality());
        dispatch(getReports());
        dispatch(getScore(null, siteId));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTab, branchSelected, isPortalWithNewReputation]);

  useEffect(() => {
    // Se consume fecha y hora para mostrar cuando fue la última actualización de los datos:
    if (hasPostingLeads || hasPostingLeadsCharts) {
      setUpdateData({
        ...updateData,
        date: momentFormaterISO(date, 'DD/MM/YYYY'),
        hour: momentFormaterISO(date, 'HH:mm')
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasPostingLeads, hasPostingLeadsCharts]);

  useEffect(() => {
    if (hideTourModalCookie) setShowTourModal(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hideTourModalCookie]);

  useEffect(() => {
    if (enabledTourReputation && !!levelValue && !hideTourReputationCookie) {
      setShowTourReputation(enabledTourReputation);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabledTourReputation, levelValue, hideTourReputationCookie]);

  if (getLoadingState())
    return <Skeleton device={device} portalWithTelBanner={portalWithTelBanner} currentTab={currentTab} />;

  return (
    <>
      <TourEstadisticas setShowTour={setShowTourStatistics} showTour={showTourStatistics} />
      <TourReputationLevel
        setShowTour={setShowTourReputation}
        showTour={showTourReputation}
        device={device}
        userLoggedId={userLoggedId}
        levelValue={levelValue}
        siteId={siteId}
      />
      {showTourModal && isVAEnabledPublisher && device === 'desktop' && (
        <Modal>
          <ModalBase
            openModal={showTourModal}
            onClose={onCloseTourInModal}
            withoutOutsideClose
            width='400px'
            height='498px'
          >
            <TourModal
              setShowTour={setShowTourStatistics}
              onClose={closeTourModal}
              title={t('panel.estadisticas.tourVA.modal.title')}
              textInfo={t('panel.estadisticas.tourVA.modal.body')}
              textPrimaryCTA={t('panel.estadisticas.tourVA.next')}
            />
          </ModalBase>
        </Modal>
      )}
      {isVAEnabledPublisher && device === 'desktop' && (
        <AlertContainer>
          <Alert
            buttonText={t('panel.estadisticas.tourVA.alert.cta')}
            buttonDataPanel='panel-alert-openTour'
            dataLayerText={{
              event: 'select_content',
              content_group: 'Estadisticas',
              content_type: 'Tour virtual',
              item_id: 'CTA - Ver tour'
            }}
            onButtonPress={() => setShowTourModal(true)}
            isNeutral
          >
            {t('panel.estadisticas.tourVA.alert.text')}
          </Alert>
        </AlertContainer>
      )}
      <ContainerLayout isDesktop={isDesktop} portalWithTelBanner={portalWithTelBanner}>
        <LeftBar isDesktop={isDesktop}>
          {!isDesktop && (
            <Header
              device={device}
              title={
                isPortalWithNewReputation && currentTab === 'score'
                  ? t('panel.reputacion.title')
                  : t('panel.estadisticas.header.title')
              }
              updateData={updateData}
              currentTab={currentTab}
              branchSelected={branchSelected}
              setBranchSelected={setBranchSelected}
              branches={branches}
              withTooltip
            />
          )}
          <PublisherDetail namePublisher={name} isPremier={premier} urlLogo={urlLogo} />
          <Tabs
            isDesktop={isDesktop}
            isAdmin={isAdmin}
            currentTab={currentTab}
            setCurrentTab={setCurrentTab}
            setQueryTab={setQueryTab}
            userIsParticular={userIsParticular}
          />
          {!isDesktop && <div className='separator' />}
        </LeftBar>
        <Main device={device}>
          <PageHeader
            headerFilter={headerFilter}
            startFilter={startFilter}
            endFilter={endFilter}
            selectFilterList={selectFilterList}
            updateFilter={updateFilter}
            isDesktop={isDesktop}
            insideHeader
            portalWithBanner={portalWithTelBanner}
            device={device}
            isGeneralStatistics
            updateData={updateData}
            currentTab={currentTab}
            branchSelected={branchSelected}
            setBranchSelected={setBranchSelected}
            branches={branches}
            title={
              isPortalWithNewReputation && currentTab === 'score'
                ? t('panel.reputacion.title')
                : t('panel.estadisticas.header.title')
            }
          />
          {getSectionContent(currentTab)}
          {!isDesktop && <FooterInformation />}
        </Main>
      </ContainerLayout>
    </>
  );
};

export default EstadisticasContainer;
